var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isActive && _vm.tourConfig
    ? _c(
        "div",
        { staticClass: "tour-overlay" },
        [
          _c("div", {
            staticClass: "tour-spotlight",
            style: _vm.spotlightStyle,
          }),
          _c("TourTooltip", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isTransitioning,
                expression: "!isTransitioning",
              },
            ],
            attrs: {
              title: _vm.currentStep.title,
              content: _vm.currentStep.content,
              position: _vm.currentStep.position,
              spotlightRect: _vm.tooltipPositionRect,
              stepIndex: _vm.currentStepIndex,
              totalSteps: _vm.totalSteps,
              isLastStep: _vm.isLastStep,
              isFirstStep: _vm.isFirstStep,
              hideFinish: !!_vm.currentStep.hideFinish,
              hidePrev: !!_vm.currentStep.hidePrev,
              awaitClick: !!_vm.currentStep.awaitClick,
              awaitClickOptional: !!_vm.currentStep.awaitClickOptional,
              congrats: !!_vm.currentStep.congrats,
              finalCongrats: !!_vm.currentStep.finalCongrats,
              aboveDrawer: !!_vm.currentStep.aboveDrawer,
              canSkip: _vm.currentStep.skipToStep != null,
            },
            on: {
              next: _vm.nextStep,
              prev: _vm.prevStep,
              finish: _vm.endTour,
              continue: _vm.handleContinue,
              skip: _vm.skipStep,
            },
          }),
          !_vm.currentStep.congrats
            ? _c("TourExitButton", {
                style: _vm.currentStep.aboveDrawer ? { zIndex: "10003" } : {},
                attrs: {
                  stepIndex: _vm.currentStepIndex,
                  totalSteps: _vm.totalSteps,
                  sidebarWidth: _vm.sidebarWidth,
                },
                on: { quit: _vm.quitTour },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }